import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FileUploader from './FileUploader'
import { actions } from '../../../../../store'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
  uploadFile: actions.upload.uploadFile,
  getStorage: actions.storage.getStorage
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileUploader)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/components/FileUploader/index.js